module.exports = __webpack_public_path__ + "static/img/signSuccess.09b058b.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/signSuccess.png
// module id = nmnn
// module chunks = 1